import Vue from 'vue'
import Router from 'vue-router'

const ApplicationDefault = () => import(
  /* webpackChunkName: "application" */
  '@/components/application/v1/Application.vue'
)

const ApplicationOffer = () => import(
  /* webpackChunkName: "application" */
  '@/components/application/offer/Application.vue'
)

const FinishedDefault = () => import(
  /* webpackChunkName: "finished" */
  '@/components/finished/v2/Finished.vue'
)

const ThanksDefault = () => import(
  /* webpackChunkName: "thanks" */
  '@/components/thanks/v2/Thanks.vue'
)

const BankVerification = () => import(
  /* webpackChunkName: "bank-verification" */
  '@/components/bank-verification/v1/BankVerification.vue'
)

const DocumentsDefault = () => import(
  /* webpackChunkName: "documents" */
  '@/components/documents/v2/Documents.vue'
)

const BankVerificationFinished = () => import(
  /* webpackChunkName: "bank-verification-finished" */
  '@/components/bank-verification/v1/BankVerificationFinished.vue'
)

// const BankingDefault = () => import(
//   /* webpackChunkName: "banking" */
//   '@/components/banking/v1/Banking.vue'
// )

const ReferralV1 = () => import(
  /* webpackChunkName: "referral" */
  '@/components/referral/v1/Referral.vue'
)

const CosignerApplicationV1 = () => import(
  /* webpackChunkName: "cosigner-application" */
  '@/components/cosigner/v1/CosignerApplication.vue'
)

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/application/',
  routes: [
    {
      path: '/',
      name: 'Application Default',
      component: ApplicationDefault
    },
    {
      path: '/offer',
      name: 'Direct Mail Campaign - Direct mail campaign with updated footer disclaimer [OPSSD-7542] (Based on v37)',
      component: ApplicationOffer
    },
    {
      path: '/demo',
      name: 'Demo',
      component: ApplicationDefault
    },
    {
      path: '/documents',
      name: 'Documents',
      component: DocumentsDefault
    },
    {
      path: '/documents/*',
      name: 'Documents Catch-all',
      component: DocumentsDefault
    },
    // {
    //   path: '/banking',
    //   name: 'Banking',
    //   component: BankingDefault
    // },
    /*
      Flinks banking flow
      - user only lands on from within application flow
    */
    // {
    //   path: '/banking/*',
    //   name: 'Banking Catch-all',
    //   component: BankingDefault
    // },

    /*
      Flinks standalone bank verification page
      - user only lands on URL from a direct link containing a valid app ID -- ?appid={id}
    */
    {
      path: '/bank-verification',
      name: 'bank-verification',
      component: BankVerification
    },
    {
      path: '/bank-verification/finished',
      name: 'bank-verification-finished',
      component: BankVerificationFinished
    },
    {
      path: '/thanks',
      name: 'Thanks',
      component: ThanksDefault
    },
    {
      path: '/thanks/*',
      name: 'Thanks Catch-all',
      component: ThanksDefault
    },
    {
      path: '/finished',
      name: 'Finished',
      component: FinishedDefault
    },
    {
      path: '/finished/*',
      name: 'Finished Catch-all',
      component: FinishedDefault
    },
    {
      path: '/session-expired',
      beforeEnter: (to, from, next) => {
        next({ path: '/finished', query: { ...to.query } })
      }
    },
    {
      path: '/referral',
      name: 'Referral',
      component: ReferralV1
    },
    {
      path: '/cosigner',
      name: 'Cosigner',
      component: CosignerApplicationV1
    },
    {
      path: '/contact-us',
      beforeEnter: () => {
        window.location.replace(`${process.env.VUE_APP_SITE_URL}/contact`)
      }
    },

    /**
     * Fallback
     */
    {
      path: '*',
      beforeEnter: (to) => {
        const queryParams = new URLSearchParams(to.query).toString()
        const redirectUrl = queryParams
          ? `//www.canadadrives.ca/?${queryParams}`
          : '//www.canadadrives.ca'
        window.location.replace(redirectUrl)
      }
    }
  ]
})
